import { tr } from '@repo/locale';
import { ConsentPathGuard } from '@repo/privacy-consent';
import { TestId } from '@repo/test-id';
import { Outlet } from 'react-router-dom';

export default function ParkingManageConsentGuard() {
  const testId = TestId.root('parkingManageConsentGuard');

  return (
    <ConsentPathGuard
      service="googleReverseGeocode"
      title={tr('owned_parking_manage:consent_guard.title')}
      testId={testId}
    >
      <Outlet />
    </ConsentPathGuard>
  );
}
